import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { getItem } from './localStorage';
import { makeRequest2 } from './makeRequest';
import { recordWhtPayment } from './urls';
import { toastify } from './toast';
import { v4 as uuidv4 } from 'uuid';

const WhtPaymentModal = ({
    visible,
    onHide,
    invoice,
    facilityId,
}) => {
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);

    const getWithholdingTax = () => {
        if (!invoice?.withholdingTaxes || !Array.isArray(invoice.withholdingTaxes)) return null;
        return invoice.withholdingTaxes.find(
            (tax) => tax.name?.toLowerCase() === 'withholding'
        ) || null;
    };

    const whtTax = getWithholdingTax();
    const fmt = (val) => Number(val || 0).toFixed(2);
    const getAutoWHTAmount = () => whtTax?.amount || invoice?.totalWithholdingTax || 0;

    const [formData, setFormData] = useState({
        amount: getAutoWHTAmount(),
        receiptNumber: `CASH-${uuidv4().substring(0, 8)}`,
        paymentMethod: 'Cash',
        paymentDate: new Date().toISOString().split('T')[0],
        notes: '',
        currencyId: '',
        checkNumber: '',
        bankName: '',
        transferReference: ''
    });

    useEffect(() => {
        if (invoice) {
            setFormData(prev => ({
                ...prev,
                amount: getAutoWHTAmount(),
                currencyId: invoice?.currency?.id || ''
            }));
        }
    }, [invoice]);

    useEffect(() => {
        if (visible) {
            setFormData(prev => ({
                ...prev,
                amount: getAutoWHTAmount(),
                receiptNumber: `CASH-${uuidv4().substring(0, 8)}`,
                paymentDate: new Date().toISOString().split('T')[0],
                notes: '',
                checkNumber: '',
                bankName: '',
                transferReference: ''
            }));
            setFile(null);
        }
    }, [visible]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const facilityId = await getItem('selectedFacilityId');

            const response = await makeRequest2(
                `${recordWhtPayment}/${facilityId}`,
                'POST',
                {
                    invoiceNumber: invoice.invoiceNumber,
                    withheldAmount: parseFloat(formData.amount)
                }
            );
            if (response.success) {
                toastify('WHT payment recorded successfully', 'success');
                onHide();
            } else {
                toastify(response.error, 'error');
            }
        } catch (error) {
            toastify(error.message, 'error');
        }
    };

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header="Record Wht Payment"
            modal
            className="p-fluid"
            style={{ width: '450px' }}
            dismissableMask={!loading}
            closeOnEscape={!loading}
        >
            <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                    <label htmlFor="amount">
                        Amount ({invoice?.currency?.code || 'KES'})
                    </label>
                    <input
                        type="number"
                        className="form-control"
                        id="amount"
                        name="amount"
                        value={formData.amount}
                        onChange={handleInputChange}
                        disabled={loading}
                        required
                        step="0.01"
                        min="0.01"
                    />
                    <small className="text-muted">
                        WHT auto-calculated: {invoice?.currency?.code || 'KES'} {fmt(getAutoWHTAmount())}
                        {whtTax && <> &nbsp;·&nbsp; Rate: {whtTax.percentage}%</>}
                    </small>
                </div>

                <div className="d-flex justify-content-end mt-4">
                    <Button
                        label="Cancel"
                        icon="pi pi-times"
                        onClick={onHide}
                        className="p-button-text btn btn-secondary me-2"
                        disabled={loading}
                        type="button"
                    />
                    <Button
                        label={loading ? 'Processing...' : 'Record Payment'}
                        icon="pi pi-check"
                        type="submit"
                        disabled={loading}
                        className="btn btn-primary"
                    />
                </div>
            </form>
        </Dialog>
    );
};

export default WhtPaymentModal;